"use strict";
var Observable_1 = require('../../Observable');
var windowCount_1 = require('../../operator/windowCount');
Observable_1.Observable.prototype.windowCount = windowCount_1.windowCount;
//# sourceMappingURL=windowCount.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/windowCount.js